@if (icon) {
  <pr-icon
    [name]="icon"
    [ngClass]="{
      'text-success-dark bg-success-light': display == 'success',
      'text-warning-dark bg-warning-light': display == 'warning',
      'text-neutral-dark bg-neutral-light': display == 'neutral',
      'text-danger bg-danger-light': display == 'danger',
    }"
  >
  </pr-icon>
}
<div
  [ngClass]="{ 'info-tooltip': tooltip }"
  [tooltip]="tooltip"
  containerClass="ea-tooltip ea-md"
  placement="bottom"
>
  <span class="text-secondary text-600">
    {{ label }}
  </span>
  <h3
    class="text-600"
    [ngClass]="{
      'text-success': display == 'success',
      'text-warning-dark': display == 'warning',
      'text-neutral-dark': display == 'neutral',
      'text-danger': display == 'danger',
    }"
  >
    @switch (true) {
      @default {
        @switch (type) {
          @case (PrCardType.PERCENT) {
            <em>{{ value | percent: '.2' }}</em>
          }
          @case (PrCardType.PERCENT_WITH_2_DECIMAL) {
            <em>{{ value | percent: '.2' }}</em>
          }
          @case (PrCardType.EURO) {
            <em>{{ value | currency: 'EUR' : 'symbol' : '.0-0' }}</em>
          }
          @default {
            <em>{{ value }}</em>
          }
        }
      }
    }
  </h3>
</div>
